window.getMapboxDirectionsStyles = (sourceName) => {
    const directionsRouteLineCasing = '#c84c46';
    const directionsRouteLine = '#c84c46';
    const waypointCircleColor = '#c84c46';
    const waypointTextColor = '#fff';

    return [
        {
            'id': 'directions-route-line-casing',
            'type': 'line',
            'source': sourceName,
            'layout': {
                'line-cap': 'round',
                'line-join': 'round'
            },
            'paint': {
                'line-color': directionsRouteLineCasing,
                'line-width': 6
            },
            'filter': [
                'all',
                ['in', '$type', 'LineString'],
                ['in', 'route', 'selected']
            ]
        },
        {
            'id': 'directions-route-line',
            'type': 'line',
            'source': sourceName,
            'layout': {
                'line-cap': 'butt',
                'line-join': 'round'
            },
            'paint': {
                'line-color': {
                    'property': 'congestion',
                    'type': 'categorical',
                    'default': directionsRouteLine,
                    'stops': [
                        ['unknown', '#4882c5'],
                        ['low', '#4882c5'],
                        ['moderate', '#f09a46'],
                        ['heavy', '#e34341'],
                        ['severe', '#8b2342']
                    ]
                },
                'line-width': 6
            },
            'filter': [
                'all',
                ['in', '$type', 'LineString'],
                ['in', 'route', 'selected']
            ]
        },
        {
            'id': 'directions-waypoint-point',
            'type': 'circle',
            'source': sourceName,
            'paint': {
                'circle-radius': 10,
                'circle-color': waypointCircleColor
            },
            'filter': [
                'all',
                ['in', '$type', 'Point'],
                ['in', 'id', 'waypoint']
            ]
        },
        {
            'id': 'directions-waypoint-label',
            'type': 'symbol',
            'source': sourceName,
            'layout': {
                'text-field': ["get","label"],
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
                'text-size': 14
            },
            'paint': {
                'text-color': waypointTextColor
            },
            'filter': [
                'all',
                ['in', '$type', 'Point'],
                ['in', 'type', 'waypoint']
            ]
        },
        {
            'id': 'directions-origin-point',
            'type': 'circle',
            'source': sourceName,
            'paint': {
                'circle-radius': 10,
                'circle-color': waypointCircleColor
            },
            'filter': [
                'all',
                ['in', '$type', 'Point'],
                ['in', 'type', 'origin']
            ]
        },
        {
            'id': 'directions-origin-label',
            'type': 'symbol',
            'source': sourceName,
            'layout': {
                'text-field': ["get","label"],
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
                'text-size': 14
            },
            'paint': {
                'text-color': waypointTextColor
            },
            'filter': [
                'all',
                ['in', '$type', 'Point'],
                ['in', 'type', 'origin']
            ]
        },
        {
            'id': 'directions-destination-point',
            'type': 'circle',
            'source': sourceName,
            'paint': {
                'circle-radius': 10,
                'circle-color': waypointCircleColor
            },
            'filter': [
                'all',
                ['in', '$type', 'Point'],
                ['in', 'type', 'destination']
            ]
        },
        {
            'id': 'directions-destination-label',
            'type': 'symbol',
            'source': sourceName,
            'layout': {
                'text-field': ["get","label"],
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
                'text-size': 14
            },
            'paint': {
                'text-color': waypointTextColor
            },
            'filter': [
                'all',
                ['in', '$type', 'Point'],
                ['in', 'type', 'destination']
            ]
        }
    ];
}